import styled, { css } from 'styled-components';
import SectionContainer from "../SectionContainer";
import PromoBgLarge from '../../assets/img/lead-large.jpg';

export const PromoSection = styled.section`
  min-height: 570px;
  padding-top: 100px;
  padding-bottom: 25px;
  
  background: transparent no-repeat center / cover;
  background-image: url(${PromoBgLarge});
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
  
  @media(min-width: 700px) {
    padding-top: 230px;
    padding-bottom: 205px;
  }
  
  @media(min-width: 1024px) {
    padding-top: 235px;
    padding-bottom: 140px;
  }
`;

export const PromoSectionContainer = styled(SectionContainer)`
  flex-direction: column;
`;

export const Heading = styled.h1`
  margin: 0;
  margin-bottom: 7px;
  padding: 0;
  
  font-size: 36px;
  line-height: 36px;
  color: ${({ theme }) => theme.white};
  
  ${props => props.smallFont && css`
    font-size: 10px;
  `};
  
  @media (min-width: 700px) {
    max-width: 390px;
    margin-bottom: 45px;
    
    font-size: 56px;
    line-height: 70px;
  };
  
  @media(min-width: 1024px) {
    max-width: 410px;
    margin-bottom: 110px;
    
    line-height: 65px;
  };
`;
